module.exports = __webpack_public_path__ + "img/3.fdf70ed8.png";